import { useMutation } from 'react-query';
import { customerRequest } from 'src/models/CRM';
import { postCustomer } from 'src/services/CRM/customers';

export default function AddCustomer() {
  return useMutation((data: customerRequest) => postCustomer(data));
}
